// extracted by mini-css-extract-plugin
export default {"empty":"EmptyState_empty__CWP1Z","icon":"EmptyState_icon__EZDXi","title":"EmptyState_title__-0N7p","desc":"EmptyState_desc__hI2wR"};